import React from 'react';

import { Alert } from '@chakra-primitives/alert';
import { Button } from '@chakra-primitives/button';

const ACTION_COLOR = {
  warning: 'fg.warning',
  error: 'fg.error',
} as const;

export interface WelcomeMessageBannerProps {
  title: string;
  testId: string;
  actionLabel?: string;
  onAction?: () => void;
  // 'error' for the problems that gate Save; advisories stay 'warning'.
  status?: keyof typeof ACTION_COLOR;
}

export const WelcomeMessageBanner: React.FC<WelcomeMessageBannerProps> = ({
  title,
  testId,
  actionLabel,
  onAction,
  status = 'warning',
}) => (
  <Alert
    status={status}
    variant="surface"
    alignItems="center"
    title={title}
    data-testid={testId}
    data-status={status}
    mb={4}
    py={2}
    endElement={
      actionLabel && onAction ? (
        <Button
          variant="plain"
          size="sm"
          color={ACTION_COLOR[status]}
          fontWeight="semibold"
          whiteSpace="nowrap"
          onClick={onAction}
        >
          {actionLabel}
        </Button>
      ) : undefined
    }
  />
);

export default WelcomeMessageBanner;
